(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["jetvoro-collection"]) return;
  try {
    
document.addEventListener('change',event=>{if(event.target.matches('[data-jv-auto-submit]'))event.target.form.submit();});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["jetvoro-header"]) return;
  try {
    
document.addEventListener('click',event=>{document.querySelectorAll('.jv-nav-dropdown[open]').forEach(el=>{if(!el.contains(event.target))el.removeAttribute('open')});});
document.addEventListener('keydown',event=>{if(event.key==='Escape'){document.querySelectorAll('.jv-nav-dropdown[open],.jv-mobile-nav[open]').forEach(el=>{el.removeAttribute('open');el.querySelector('summary').focus()});}});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["jetvoro-product"]) return;
  try {
    
document.addEventListener('click',event=>{const button=event.target.closest('[data-jv-thumb]');if(!button)return;const parent=button.closest('[data-jv-product]');const image=parent.querySelector('.jv-product-image');if(image){image.removeAttribute('srcset');image.src=button.dataset.jvThumb;image.alt=button.dataset.alt||'';}parent.querySelectorAll('[data-jv-thumb]').forEach(el=>{el.classList.toggle('is-selected',el===button);el.setAttribute('aria-pressed',String(el===button));});});
document.addEventListener('change',event=>{if(!event.target.matches('[data-jv-variant]'))return;const choice=event.target.selectedOptions[0],parent=event.target.closest('[data-jv-product]'),button=parent.querySelector('[data-jv-add]');button.disabled=choice.dataset.available!=='true';button.querySelector('span').textContent=button.disabled?button.dataset.soldOut:button.dataset.label;parent.querySelector('[data-jv-price]').textContent=choice.dataset.price;});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
